import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';
import {toFormikValidationSchema} from 'zod-formik-adapter';

import {FormWithButtons} from '@flexinet/ui-components';

import {Order} from '../types';
import {useParams} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<Order, 'id'>,
    handleSubmit: (values: Order) => void,
    handleCancel?: () => void
}) => {
    const {id: customerId} = useParams();

    const onSubmit = (values: Order) => {
        console.debug(values)
        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {customerId: customerId} as Order;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(RecordSchema)}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
